<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post20-stratotanker-mission-03-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post20-stratotanker-mission-03-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.75183854580884;"
    data-aspect-ratio="0.752"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post20-stratotanker-mission-03-xs-img"
      class="g-post20-stratotanker-mission-03-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-03-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.7214%;margin-top:-9.6px;left:49.098%;width:106px;"
    >
      <p class="g-pstyle1">Refueling port</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:78.5059%;margin-top:-9.6px;left:49.1476%;width:65px;"
    >
      <p class="g-pstyle2">7.65cm</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs"
      style="top:80.8796%;left:49.1475%;width:33.3333%;"
    >
      <p class="g-pstyle3">The receptacle is roughly the size of a baseball.</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:61.8743%;margin-top:-9.6px;left:6.5249%;width:97px;"
    >
      <p class="g-pstyle0">Baseball ball</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post20-stratotanker-mission-03-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.47439386672562;"
    data-aspect-ratio="1.474"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post20-stratotanker-mission-03-sm-img"
      class="g-post20-stratotanker-mission-03-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-03-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:54.5182%;margin-top:-9.6px;left:76.3118%;width:65px;"
    >
      <p class="g-pstyle1">7.65cm</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs"
      style="top:57.5303%;left:76.3118%;width:21.5686%;"
    >
      <p class="g-pstyle2">The receptacle is roughly the size of a baseball.</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.5039%;margin-top:-9.6px;left:6.4633%;width:97px;"
    >
      <p class="g-pstyle3">Baseball ball</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:48.1581%;margin-top:-9.6px;left:76.3791%;width:106px;"
    >
      <p class="g-pstyle0">Refueling port</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post20-stratotanker-mission-03-md"
    class="g-artboard"
    style="min-width: 660px;aspect-ratio: 1.88971915190887;"
    data-aspect-ratio="1.89"
    data-min-width="660"
  >
    <div
      id="g-post20-stratotanker-mission-03-md-img"
      class="g-post20-stratotanker-mission-03-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-03-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.9947%;margin-top:-9.6px;left:73.2573%;width:65px;"
    >
      <p class="g-pstyle1">7.65cm</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs"
      style="top:56.9779%;left:73.2573%;width:16.6667%;"
    >
      <p class="g-pstyle2">The receptacle is roughly the size of a baseball.</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.4433%;margin-top:-9.6px;left:16.8754%;width:97px;"
    >
      <p class="g-pstyle3">Baseball ball</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.6957%;margin-top:-9.6px;left:73.2573%;width:106px;"
    >
      <p class="g-pstyle0">Refueling port</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-18 12:24 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-18 12:24 -->
<!-- ai file: post20-stratotanker-mission-03.ai -->
<style lang="scss">
  #g-post20-stratotanker-mission-03-box {
    container-type: inline-size;
    container-name: g-post20-stratotanker-mission-03-box;
  }
  #g-post20-stratotanker-mission-03-box,
  #g-post20-stratotanker-mission-03-box .g-artboard {
    margin: 0 auto;
  }
  #g-post20-stratotanker-mission-03-box p {
    margin: 0;
  }
  #g-post20-stratotanker-mission-03-box .g-aiAbs {
    position: absolute;
  }
  #g-post20-stratotanker-mission-03-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post20-stratotanker-mission-03-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post20-stratotanker-mission-03-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post20-stratotanker-mission-03-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post20-stratotanker-mission-03-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post20-stratotanker-mission-03-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post20-stratotanker-mission-03-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-post20-stratotanker-mission-03-md {
        display: block !important;
      }
    }
  }
  #g-post20-stratotanker-mission-03-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-03-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-03-xs .g-pstyle0 {
    font-weight: 300;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-03-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-03-xs .g-pstyle2 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-03-xs .g-pstyle3 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-03-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-03-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-03-sm .g-pstyle0 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-03-sm .g-pstyle1 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-03-sm .g-pstyle2 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-03-sm .g-pstyle3 {
    font-weight: 300;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-03-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-03-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-03-md .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
  }
  #g-post20-stratotanker-mission-03-md .g-pstyle1 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
  }
  #g-post20-stratotanker-mission-03-md .g-pstyle2 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-03-md .g-pstyle3 {
    font-weight: 300;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
  }

  /* Custom CSS */
</style>
